import { apiCall } from './base';

export const fetchCandidateRole = (name = '') =>
  apiCall(`/candidate-roles`, { method: 'GET', params: { name } });

  export const updateCandidateRole = (hash, { immediately = false, ...data }) =>
  apiCall(`/candidate-roles/${hash}`, { method: 'PUT', data, immediately });

export const postCandidateRole = ({ immediately = false, ...data }) =>
  apiCall(`/candidate-roles`, { method: 'POST', data, immediately });

export const deleteCandidateRole = (hash, { immediately = false, ...data }) =>
  apiCall(`/candidate-roles/${hash}`, {
    method: 'DELETE',
    data,
    immediately,
  });